import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
import "./LoginForm.css";
// import "../../styles/style.css";
import AiImage from "../../assets/images/ai2.jpg";
// import LoginImage from "../../assets/images/Login.jpg";
// import RegisterImage from "../../assets/images/Register.jpg";
import { login, registerUser } from '../../services/apiService';
import { Link } from "react-router-dom";

const LoginForm = ({ onLogin }) => {
  const [isLoginActive, setIsLoginActive] = useState(true);

  const switchToSignUp = () => {
    setIsLoginActive(false);
  };

  const switchToLogin = () => {
    setIsLoginActive(true);
  };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  
  const [loginError, setLoginError] = useState(
    {
      last_name: "",
      email: "",
      password: "",
    }
  );

  const [formData, setFormData] = useState({
    name: "",
    last_name: "",
    email: "",
    password: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  useEffect(() => {
    document.body.className = "login-page-main";
    return () => {
      document.body.className = "";
    };
  }, []);

  const validateLogin = () => {
    const newErrors = {};
    if (!email.trim()) newErrors.email = "Email is required";
    if (!password.trim()) newErrors.password = "Password is required";
    setLoginError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {

    e.stopPropagation();
    e.preventDefault();

    if (!validateLogin()) return;
  
    setLoading(true);
    try {
      //const response = await axios.post('http://localhost:5000/login', { email, password });
      const response = await login(email, password);
      if (response.data.status === 'Success') {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("username", response.data.user.name);
        localStorage.setItem("lastname", response.data.user.last_name);
        localStorage.setItem("is_admin", response.data.user.is_admin);
        if(response.data.user.image_url !==null){
          localStorage.setItem("imageurl", response.data.user.image_url);
        }else{
          localStorage.setItem("imageurl", "");
        }
        onLogin();
        navigate("/home");
      } else {
        setError("Invalid credentials");
      }
    } catch (error) {
      setError("Failed to login. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    // const validationErrors = validateForm();
    // if (Object.keys(validationErrors).length == 0) {
      setErrorMessage('');
      if (validateForm()) {
        try {
          const response = await registerUser(formData);
          if(response.data.status === 'Success'){
            setFormData({
              name: "",
              last_name: "",
              email: "",
              password: "",
            });
            switchToLogin();
          }else{
            let newErrors = {};
            newErrors = response.data.message;
            console.log(response.message);
            setErrorMessage(newErrors);
          }
        } catch (error) {
          console.error("Failed to store data:", error.message);
        }
    }
  };
  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'First Name is required';
    }
    if (!formData.last_name.trim()) {
      newErrors.last_name = 'Last Name is required';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = 'Invalid email format';
    }
    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters long';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
    //return errors;
  };
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  

  return (
    <div className={`logincontainer ${!isLoginActive ? 'signup-active' : ''}`}>
      <div className="form-box">
        {isLoginActive ? (
          <form onSubmit={handleSubmit}>
            <div className="sign-in-container">
              <h1>Login</h1>
              <input
              type="email"
              id="exampleInputEmail1"
              name="email"
              className={`login-input ${loginError.email ? 'error' : ''}`}
              aria-describedby="emailHelp"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              />
              <input type="password" 
              name="password"
              className={`login-input ${loginError.password ? 'error' : ''}`}
              id="exampleInputPassword1"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              />
              {error && <div className="alert alert-danger">{error}</div>}
              <button
              type="submit"
              className="login-button"
              >Login</button>
              <span className="login-span" onClick={switchToSignUp}>Don't have an account? Sign Up</span>
            </div>
          </form>
        ) : (
          <div className="sign-up-container">
            <form onSubmit={handleRegister}>
              <h1>Sign Up</h1>
              <input
                type="text"
                id="name"
                name="name"
                className={`login-input ${errors.name ? 'error' : ''}`}
                placeholder="First Name"
                value={formData.name}
                onChange={handleInputChange}
               />
               {/* {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>} */}
               <input
                type="text"
                id="last_name"
                name="last_name"
                className={`login-input ${errors.last_name ? 'error' : ''}`}
                placeholder="Last Name"
                value={formData.last_name}
                onChange={handleInputChange}
               />
               {/* {errors.last_name && <p style={{ color: 'red' }}>{errors.last_name}</p>} */}
              <input 
              type="email"
              id="email"
              name="email"
              className={`login-input ${errors.email ? 'error' : ''}`}
              aria-describedby="emailHelp"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
               />
               {/* {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>} */}
              <input 
              type="password"
              id="password"
              name="password"
              className={`login-input ${errors.password ? 'error' : ''}`}
              placeholder="Password"
              value={formData.password}
              onChange={handleInputChange}
                />
                {/* {errors.password && <p style={{ color: 'red' }}>{errors.password}</p>} */}
              <button type="submit" className="login-button">Sign Up</button>
            </form>
              <span className="login-span" onClick={switchToLogin}>Already have an account? Login</span>
              {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
          </div>
        )}
      </div>

      {isLoginActive ? (
        <div className="login-info-box">
          <img src="/Assets/Login2.jpg" alt="Login" />
        </div>
      ) : (
        <div className="info-box">
          <img src="/Assets/Register2.jpg" alt="Sign Up" />
        </div>
      )}
    </div>
  );
};

export default LoginForm;
